// extracted by mini-css-extract-plugin
export default {"notificationDate":"Notification_notificationDate__88dz5"};